import { useState } from 'react'
import PropTypes from 'prop-types'
import ExpandTextDialog from '../dialog/ExpandTextDialog'

export const Input = ({
    inputParam,
    value,
    onChange,
    disabled = false,
    showDialog,
    dialogProps,
    onDialogCancel,
    onDialogConfirm
}) => {
    const [myValue, setMyValue] = useState(value ?? '')

    const getInputType = (type) => {
        switch (type) {
            case 'string':
                return 'text'
            case 'password':
                return 'password'
            case 'number':
                return 'number'
            default:
                return 'text'
        }
    }

    return (
        <>
            <div className="my-1.5">
                <input
                    id={inputParam.name}
                    type={getInputType(inputParam.type)}
                    placeholder={inputParam.placeholder}
                    className={`p-2 w-64 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring focus:border-blue-500 ${disabled ? 'bg-gray-200 cursor-not-allowed' : 'bg-white'} 
                    ${inputParam.rows ? 'resize-none' : ''} ${inputParam.rows ? 'h-24' : ''}`}
                    value={myValue}
                    name={inputParam.name}
                    onChange={(e) => {
                        setMyValue(e.target.value)
                        onChange(e.target.value)
                    }}
                    disabled={disabled}
                    step={inputParam.step ?? 1}
                    style={{height: "30px"}}
                />
            </div>
            {showDialog && (
                <ExpandTextDialog
                    show={showDialog}
                    dialogProps={dialogProps}
                    onCancel={onDialogCancel}
                    onConfirm={(newValue, inputParamName) => {
                        setMyValue(newValue)
                        onDialogConfirm(newValue, inputParamName)
                    }}
                />
            )}
        </>
    )
}

Input.propTypes = {
    inputParam: PropTypes.object,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    onChange: PropTypes.func,
    disabled: PropTypes.bool,
    showDialog: PropTypes.bool,
    dialogProps: PropTypes.object,
    onDialogCancel: PropTypes.func,
    onDialogConfirm: PropTypes.func
}

// import { useState } from 'react';
// import PropTypes from 'prop-types';
// import { useEditor, EditorContent, EditorProvider } from '@tiptap/react';
// import StarterKit from '@tiptap/starter-kit';
// import ExpandTextDialog from '../dialog/ExpandTextDialog';
// import { Placeholder } from '@tiptap/extension-placeholder';

// export const Input = ({
//   inputParam,
//   value,
//   onChange,
//   disabled = false,
//   showDialog,
//   dialogProps,
//   onDialogCancel,
//   onDialogConfirm,
//   className
// }) => {
//   const [myValue, setMyValue] = useState(value ?? '');

//   const extensions = [
//     StarterKit,
//     Placeholder.configure({
//       placeholder: 'Enter your text here...', // Your placeholder text
//     }),
//     // Add other extensions here
//   ];

//   return (
//     <>
      

//       <EditorProvider
//       extensions={extensions}
//       content={myValue}
//       onUpdate={({ editor }) => {
//         const plainText = editor.getText(); 
//         setMyValue(plainText)
//         onChange(plainText)
//       }}
//       editorProps={{
//         attributes: {
//           class: className || `text-sm border border-gray-300 rounded-md shadow-sm focus:outline-none focus:border-2 focus:border-blue-500 w-64  ${disabled ? 'bg-gray-200 cursor-not-allowed' : 'bg-white'}`, 
//         },
//       }}
//     >
//       {/* Editor content goes here */}
//     </EditorProvider>

//              {showDialog && (
//                 <ExpandTextDialog
//                     show={showDialog}
//                     dialogProps={dialogProps}
//                     onCancel={onDialogCancel}
//                     onConfirm={(newValue, inputParamName) => {
//                         setMyValue(newValue)
//                         onDialogConfirm(newValue, inputParamName)
//                     }}
//                 />
//             )}
//     </>
//   );
// };

// Input.propTypes = {
//   inputParam: PropTypes.object,
//   value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
//   onChange: PropTypes.func,
//   disabled: PropTypes.bool,
//   showDialog: PropTypes.bool,
//   dialogProps: PropTypes.object,
//   onDialogCancel: PropTypes.func,
//   onDialogConfirm: PropTypes.func,
// };

// export default Input;
